export default __webpack_public_path__ + "5052a9ee45cd3d8381a56b83fd07e260.svg";